import { apiService } from 'shared/api'
import { getResponseStatus } from 'shared/utils/errors'

import { NewsletterFormType } from './types'

const api = apiService()

export const signUpToNewsletter = async ({
  email,
  formType = 'newsletter-agreement'
}: {
  email: string
  formType?: NewsletterFormType
}) => {
  try {
    return api.post(`/newsletter/sign-up`, { email, formType })
  } catch (e) {
    // 422 is expected error when email is already in the newsletter
    if (getResponseStatus(e) === 422) return

    throw e
  }
}

export const signOutFromNewsletter = async ({ email }: { email: string }) => {
  try {
    return api.post(`/newsletter/sign-out`, { email })
  } catch (e) {
    // 422 is expected error when email is not in the newsletter
    if (getResponseStatus(e) === 422) return

    throw e
  }
}
